import React from 'react';

import Header from './Header';
import Footer from './Footer';

const Layout = props => {
	return (
		<div className='gradient'>
			<Header siteTitle={'template'} page={props.page} />
			<main className='h-auto bg-ab-inbev-light-gray min-h-screen-90 '>{props.children}</main>
			<Footer page={props.page} />
		</div>
	);
};

export default Layout;
